
import $ from "jquery";


const accordion = (() => {
  const defaultAccordion = () => {
    const accordionItem = document.getElementsByClassName('js-trigger-accordion');

    for (let i = 0; i < accordionItem.length; i += 1) {
      accordionItem[i].addEventListener('click', function (event) {
        event.currentTarget.classList.toggle('js-active');
        const accordionContent = this.nextElementSibling;
        accordionContent.classList.toggle('js-active');
      });
    }
  };

  const parentClassAccordion = () => {
    const accordionItem = document.getElementsByClassName('js-trigger-accordion-parents');

    for (let i = 0; i < accordionItem.length; i += 1) {
      accordionItem[i].addEventListener('click', function (event) {
        event.currentTarget.classList.toggle('js-active');
        const accordionContent = this.nextElementSibling;
        const accordionParentContent = this.closest(".accordion-item");
        console.log(accordionParentContent);
        accordionContent.classList.toggle('js-active');
        accordionParentContent.classList.toggle('js-active');
      });
    }
  };
  
  const scrollAnchor = () => {
    // window.addEventListener('scroll', function() {
    //   const participationLists = document.querySelectorAll('.participation-list.scroll-list');

    //   participationLists.forEach(function(participationList, index) {
    //       const offsetTop = participationList.offsetTop;
          
    //       if (window.scrollY >= offsetTop) {
    //           participationList.classList.add('active');
    //           console.log("Index:", index);
    //       } else {
    //           participationList.classList.remove('active');
    //       }
    //   });
    // });
    
  };

  const cmkAccordion = () => {
    // Tüm tab item'ları seç
    document.addEventListener("DOMContentLoaded", function() {
      const accordionTitles = document.querySelectorAll(".become-customer-accordion .accordion-title");
    
      accordionTitles.forEach(title => {
        title.addEventListener("click", function() {
          const content = this.nextElementSibling;
          const allContents = document.querySelectorAll(".become-customer-accordion .accordion-content");
          const allItems = document.querySelectorAll(".become-customer-accordion .accordion-item");
    
          // Tüm akordion içeriklerine, başlıklara ve parent itemlere js-active sınıfını kaldır
          allContents.forEach(item => {
            item.classList.remove("js-active");
          });
    
          accordionTitles.forEach(item => {
            item.classList.remove("js-active");
          });
    
          allItems.forEach(item => {
            item.classList.remove("js-active");
          });
    
          // Tıklanan akordion içeriğine, başlığına ve parent iteme js-active sınıfını ekle
          content.classList.add("js-active");
          this.classList.add("js-active");
          this.closest(".accordion-item").classList.add("js-active");
        });
      });
    });

  };

  const init = () => {
    defaultAccordion();
    parentClassAccordion();
    scrollAnchor();
    cmkAccordion();
  };

  return {
    init,
  };
})();

export default accordion;
